module.exports = __webpack_public_path__ + "img/49_16.48756cee.png";